// Generated file - do not change manually!
/**
 * Defines where the <code>ui5-toast</code> will be placed.
 */
export var ToastPlacement;
(function (ToastPlacement) {
    /**
     * <code>ui5-toast</code> is placed at the <code>BottomCenter</code> position of its container. Default placement (no selection)
     */
    ToastPlacement["BottomCenter"] = "BottomCenter";
    /**
     * <code>ui5-toast</code> is placed at the <code>BottomEnd</code> position of its container.
     */
    ToastPlacement["BottomEnd"] = "BottomEnd";
    /**
     * <code>ui5-toast</code> is placed at the <code>BottomStart</code> position of its container.
     */
    ToastPlacement["BottomStart"] = "BottomStart";
    /**
     * <code>ui5-toast</code> is placed at the <code>MiddleCenter</code> position of its container.
     */
    ToastPlacement["MiddleCenter"] = "MiddleCenter";
    /**
     * <code>ui5-toast</code> is placed at the <code>MiddleEnd</code> position of its container.
     */
    ToastPlacement["MiddleEnd"] = "MiddleEnd";
    /**
     * <code>ui5-toast</code> is placed at the <code>MiddleStart</code> position of its container.
     */
    ToastPlacement["MiddleStart"] = "MiddleStart";
    /**
     * <code>ui5-toast</code> is placed at the <code>TopCenter</code> position of its container.
     */
    ToastPlacement["TopCenter"] = "TopCenter";
    /**
     * <code>ui5-toast</code> is placed at the <code>TopEnd</code> position of its container.
     */
    ToastPlacement["TopEnd"] = "TopEnd";
    /**
     * <code>ui5-toast</code> is placed at the <code>TopStart</code> position of its container.
     */
    ToastPlacement["TopStart"] = "TopStart";
})(ToastPlacement || (ToastPlacement = {}));
